export const SUBSCRIPTION_TRIAL_PERIOD_PAYROLL_RUNS = 2;

export enum FreeTrialPayrollStatus {
  COMPLETED = "COMPLETED",
  REMAINING = "REMAINING",
}
